export const faqs: { q: string; a: string }[] = [
  {
    q: 'Do I need an electrician to install the M1 PRO?',
    a: 'No. The M1 PRO is a rechargeable, wireless light. There is no wiring to the pool and no drilling where the approved mounting method permits.',
  },
  {
    q: 'How many lights do I need?',
    a: 'Use the lighting system recommender as a starting point. Actual coverage depends on pool dimensions, depth, placement and the effect you want. You can adjust quantities freely.',
  },
  {
    q: 'How do I charge it?',
    a: 'Lift the light off its magnetic base and charge it with USB-C. The charging port sits behind a blue protective cover on the rear.',
  },
  {
    q: 'How long does a charge last?',
    a: 'The manufacturer advertises up to 20 hours of operation under applicable conditions. Run time varies with color, mode and water temperature.',
  },
  {
    q: 'What surfaces does the Magnetic Mount System work on?',
    a: 'Confirmed compatible surfaces will be published after testing. The system is not claimed to work on every surface.',
  },
  {
    q: 'Can I use the M1 PRO in saltwater, on boats or on docks?',
    a: 'Not yet confirmed. Saltwater, marine-vessel and dock applications will be listed only after compatibility has been verified.',
  },
  {
    q: 'What warranty do I get?',
    a: 'Systems of 4, 6, 8, 12 and 24 lights carry a Limited Lifetime Warranty. Single lights and the 2-light Duo System carry a 1-Year Limited Warranty. See the Warranty page for full terms.',
  },
  {
    q: 'How do the system prices work?',
    a: 'A single M1 PRO is $29.95. Systems include the stated number of lights at a lower total: 2 lights $54.90, 4 lights $99.95, 6 lights $149.95, 8 lights $189.95, 12 lights $269.95 and 24 lights $479.95. Savings are measured against buying the same number of lights individually. Systems of 4 or more lights include a Limited Lifetime Warranty; 1 and 2 lights include a 1-Year Limited Warranty.',
  },
];
